import { useMediaQuery } from "@mui/material";

const useScreenSize = (): boolean => {
  const isMobile = useMediaQuery("(max-width:450px)");
  return isMobile;
};

export default useScreenSize;
